export default "__VITE_ASSET__4c94ffa7__"